export default "__VITE_ASSET__C6Awn81C__"